import React, {memo} from 'react';
import {NavLink} from 'react-router-dom';
import {PAGES_URL} from '../../helpers/constants';
import {DashboardLayout} from '../../components';
import {useGovtLookupHomeLayout} from '../../hooks/useGovtLookupHomeLayout';

const ROUTES = [
  {
    name: 'Individual Lookup',
    path: PAGES_URL.INDIVIDUAL_LOOKUP,
    key: 'individual',
  },
  {
    name: 'Business Lookup',
    path: PAGES_URL.BUSINESS_LOOKUP,
    key: 'business',
  },
];

function Layout({children}) {
  const getPermission = useGovtLookupHomeLayout();

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Government Lookup</p>
      }
    >
      <div className="py-3">
        <div className="mt-4 rounded-md bg-[#F7F7F7] w-fit p-1 flex items-center gap-2 overflow-x-auto">
          {ROUTES.map(route => (
            <NavLink
              key={route.key}
              end
              to={route.path}
              className={({isActive}) =>
                `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                  isActive
                    ? 'text-black bg-white shadow-tabs'
                    : 'text-grey-500 bg-transparent'
                }`
              }
            >
              {route.name}
            </NavLink>
          ))}
        </div>
      </div>
      {children}
    </DashboardLayout>
  );
}

export default memo(Layout);
